import React from 'react';
import {
    ActionContainer,
} from './style-component';
import ShareBenefitComponent from './components/share-benefit';
import { BenefitActionProps } from './benefit-action-types';
import { QRBenefit } from './components/qr-benefit';
import { DownloadBenefit } from './components/download-benefit';
import CodeBenefit from './components/code-benefit';

const BenefitAction: React.FC<BenefitActionProps> = ({ 
    type, 
    benefit,
}) => {

    const renderContent = () => {
        switch (type) {
            case 'QR':
                return (
                    <QRBenefit benefit={benefit}/>
                );
            case 'DOWNLOAD':
                return (
                    <DownloadBenefit benefit={benefit}/>
                );
            case 'REDEEM':
            case 'EXTERNAL':
                return (
                    <ShareBenefitComponent benefit={benefit}/>
                );
            case 'CODE':
                return (
                    <CodeBenefit benefit={benefit}/>
                );
            default:
                return <></>;
        }
    };

    return (
        <ActionContainer>
            {renderContent?.()}
        </ActionContainer>
    );
};

export default BenefitAction;
